/*  ==========================================================================
    ADDITIONALS LIST VIEW
    ========================================================================== */

/*
 * IMPORTS
 */

// node modules imports
import $ from 'jquery';
import 'jquery-inview';

// local imports
import * as vars from '../../globals/variables';
import * as utils from '../../utilities/utils';

/*
 * MODULE
 */

// hook function
function funcHook(container,data) {
}

// custom function
function funcCustom(container,data) {

    // magnific popup
    utils.mfp.initGallery(container);

    // accordion function
    $(container).find('.bn-additional-slide-box').each(function () {
        let $this = $(this);
        utils.accordions.initSimpleAccordion($this);
    });

    container.find('.bn-additional-slide-box__button').on('click', function (e) {
        let cookie_name = 'bn-wishlist',
            add_id = $(this).data('additional_id');

        // let wishlist = Cookies.getJSON(cookie_name);
        let wishlist = utils.general.getCookie(cookie_name);

        if(wishlist) {
            wishlist = JSON.parse(wishlist);
            wishlist[add_id] = {
                amount: 1,
                comment: ''
            };

            console.log(wishlist);

        } else {
            wishlist = {};
            wishlist[add_id] = {
                amount: 1,
                comment: ''
            };
        }

        utils.general.setCookie(cookie_name, wishlist, 1);

        utils.general.updateMerkliste();
    });

}

// initialization
export function initAdditionalsListView($element) {
    let container = $element.find('.eh-service');

    // config
    let config = {
        addParams: {
            limit: 1000
        },
        container: container,
        funcCustom: funcCustom,
        funcHook: funcHook,
        type: 'additional',
        subtype: 'list-view'
    };

    // set category/ies
    if ($(container).attr('data-category')) {
        let category = $(container).attr('data-category');
        config.addParams.additionalcategories = category;
    }

    // ehotelier service initialization (if element is in view)
    $element.one('inview', function() {
        utils.ehotelierLoader.initEhotlierService(config);
    });

}


// WEBPACK FOOTER //
// ./source/js/modules/lib/additionals-list-view.js